export default __webpack_public_path__ + "static/media/brave_zone_xl2.14ebfb40.png";